import React, { Component } from "react";

import { Refresh2 } from "iconsax-react";

import styled, { keyframes } from "styled-components";
export default class TimerComponent extends Component {
  state = {
    minutes: 3,
    seconds: 0,
  };

  componentDidMount() {
    this.handleTime();
  }

  componentWillUnmount() {
    clearInterval(this.myInterval);
  }

  handleTime = () => {
    this.myInterval = setInterval(() => {
      const { seconds, minutes } = this.state;

      if (seconds > 0) {
        this.setState(({ seconds }) => ({
          seconds: seconds - 1,
        }));
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(this.myInterval);
        } else {
          this.setState(({ minutes }) => ({
            minutes: minutes - 1,
            seconds: 59,
          }));
        }
      }
    }, 1000);
    this.setState({
      seconds: 0,
      minutes: 3,
    });
  };

  render() {
    const { minutes, seconds } = this.state;
    return (
      <div className="text-muted">
        {minutes === 0 && seconds === 0 ? (
          <StyledResendOTPButton
            role="button"
            onClick={() => {
              this.handleTime();
              this.props.handleGetCodeAgain();
            }}
            className="btn-custom"
          >
            <Refresh2
              size="20"
              color="var(--text-color-muted)"
              className="refresh ms-2"
            />
            ارسال مجدد
          </StyledResendOTPButton>
        ) : (
          <p className="text-center text-muted">
            <span className="text-primary">
              {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
            </span>{" "}
            تا ارسال مجدد
          </p>
        )}
      </div>
    );
  }
}
const animation = keyframes`
  0%{
    transform: rotate(0), ;
  }
  50%{
    transform: rotate(-360deg) scale(1.2);
  }
  100%{
    transform: rotate(-360deg) scale(1);
  }
`;
const StyledResendOTPButton = styled.span`
  cursor: pointer;
  & .refresh {
    animation: ${animation} linear 1s 0.5s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }
`;
